module.exports = __webpack_public_path__ + "img/banner_icon_5.c0af39f6.jpg";